import React, {useState} from "react";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

export default function Dia_Reprod_Genes() {

const [dialogOpen, setdialogOpen] = useState(false);
const handleDialogOpen = () => {setdialogOpen(true);};
const handleDialogClose = () => {setdialogOpen(false);};

return(
<>      
        <Button onClick={handleDialogOpen} variant="outlined" size="small" sx={{ borderRadius:'16px', borderColor: 'common.white',mb:2, padding: '3px 8px 0px 8px',}} >
           <Typography variant="h6" color='common.white' gutterBottom 
                                sx={{fontWeight: '400', fontSize: {sx: '55%', sm: '45%', md: '75%', lg: '90%', xl: '80%' }, '&:hover': { color: 'primary.light'},   }}>
                                Associated Genes
            </Typography>
        </Button>


            <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth='xl'
                    sx={{ '& .MuiDialogContent-root': { display: 'flex', flexDirection: 'column', m: 'auto', width: '100%',}, 
                          '& .MuiDialogActions-root': { padding: 1,},}}>

                        <DialogTitle sx={{backgroundColor: 'background.default'}}>
                            <Typography  variant='h3' color='primary' align= 'center' sx={{fontFamily: 'Poppins', fontWeight: '500', mt:4}} >
                            REPRODUCTIVE SYSTEM<br /> TESTED GENES
                            </Typography>
                        </DialogTitle>
                        
                        <DialogContent sx={{p:4, backgroundColor: 'background.default'}}>        
                                
                                <Typography variant='h5' color='primary' align='center'>
                                <br />

                                'BRCA1',<br />
                                'BRCA2',<br />
                                'MLH1',<br />
                                'LH2',<br />
                                'MLH6',<br />
                                'HOXB13',<br />
                                'CHEK2',<br />
                                'FANCA',<br />
                                'EPCAM',<br />
                                'NBN',<br />
                                'ATM',<br />
                                 'PMS2',<br />
                                 'RAD51B',<br />
                                 'RAD51C',<br />
                                 'RAD51D',<br /> 
                                 'TP53',<br />
                                 'PALB2',<br /> 
                                 'BRIP1', <br />
                                 'MED1',<br /> 'ERBB3',<br /> 'CASP8',<br /> 'HLA-A',<br /> 'TGFBR2',<br /> 'FGFR3',<br />
                                     'MLH3',<br /> 'MSH6', <br />'TGBR2',<br /> 'PMS1',<br />
                                     'MSH2',<br />
                                     'KIT', <br />'KRAS',<br /> 'NRAS',<br /> 'BRAF',<br />
                                     'RB1',<br /> 'PTEN',<br /> 'JAZF1',<br /> 'SUZ12',<br /> 'YWHAE',<br /> 'NUTM', <br />
                                     'p53'<br /><br />
                                    
                                 <br />
                                </Typography>

                                  </DialogContent>
                                  
                    <DialogActions sx={{backgroundColor: 'background.default'}}>
                        <Button onClick={handleDialogClose} sx={{m:4}}>BACK</Button>
                    </DialogActions>

            </Dialog>



</>
)}